import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import {Grid} from '@material-ui/core'
import messages from '../../../assets/messages'
import NotificationBar from '../NotificationBar'

export function ErrorTableLayout(): ReactElement {
  return (
    <Grid>
      <NotificationBar status="error">
        <Trans {...messages.generalError} />
      </NotificationBar>
    </Grid>
  )
}
